import { EventsMap } from 'redux-beacon';
import {
  APP_INIT,
  UPDATE_CURRENT_PAGE,
  UpdateCurrentPageAction
} from 'components/Pagelayout/actions';
import { PageState } from 'models/PageState';
import { isCheckoutPage } from 'models/CheckoutPageModel';
import {
  getAddContactInfoEvent,
  getAddPaymentEvent,
  getAddShippingInfoEvent,
  getAddToCartEvent,
  getBeginCheckoutEvent,
  getChangePaymentMethodEvent,
  getContinueToPaymentEvent,
  getRemoveFromCartEvent
} from 'store/googleTagManager/events';
import {
  GTM_ADD_PAYMENT_INFO,
  GTM_ADD_TO_CART,
  GTM_CHANGE_PAYMENT_METHOD,
  GTM_REMOVE_FROM_CART,
  GTM_VOYADO_CART_UPDATE,
  GtmCartItemAction,
  GtmChangePaymentMethodAction,
  GtmVoyadoCartUpdateAction,
  GTM_ADD_SHIPPING_INFO,
  GTM_CONTINUE_TO_PAYMENT,
  GTM_ADD_CONTACT_INFO
} from 'store/googleTagManager/actions';
import { getVoyadoCartEvent } from '../events/voyadoEvents';

export const CheckoutEventsMap: EventsMap = {
  [APP_INIT]: (_, state: PageState) => {
    if (isCheckoutPage(state.currentPage)) {
      return getBeginCheckoutEvent(state);
    }

    return undefined;
  },
  [UPDATE_CURRENT_PAGE]: (action: UpdateCurrentPageAction, state: PageState) => {
    if (isCheckoutPage(action.newPage)) {
      return getBeginCheckoutEvent(state);
    }

    return undefined;
  },
  [GTM_REMOVE_FROM_CART]: (action: GtmCartItemAction, prevState: PageState) => {
    return getRemoveFromCartEvent(action, prevState);
  },
  [GTM_ADD_TO_CART]: (action: GtmCartItemAction, prevState: PageState) => {
    return getAddToCartEvent(action, prevState);
  },
  [GTM_ADD_PAYMENT_INFO]: (_, prevState: PageState) => {
    return getAddPaymentEvent(prevState);
  },
  [GTM_VOYADO_CART_UPDATE]: (action: GtmVoyadoCartUpdateAction, state: PageState) => {
    return getVoyadoCartEvent(action, state);
  },
  [GTM_CHANGE_PAYMENT_METHOD]: (action: GtmChangePaymentMethodAction, state: PageState) => {
    return getChangePaymentMethodEvent(action, state);
  },
  [GTM_ADD_SHIPPING_INFO]: () => {
    return getAddShippingInfoEvent();
  },
  [GTM_CONTINUE_TO_PAYMENT]: () => {
    return getContinueToPaymentEvent();
  },
  [GTM_ADD_CONTACT_INFO]: () => {
    return getAddContactInfoEvent();
  }
};
